import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ReleaseSpaceBookingInput } from '../../../models/bookings.model';
import { IdWithRevision } from '../../../models/masterdata.model';
import {
  BulkChangeSpaceInput,
  BulkCopyInput,
  BulkEditInput,
  BulkInput,
  EditReservationDetails,
  InOfficeDashboardRequest,
  MeetingDashboardResponse,
  MeetingsDashboardInput,
  MeetingWaitlistDashboard,
  ReservationDetails,
  ReservationItemsInput,
  ReservationItemsResponse,
  SpaceAvailabilityInput,
  SpaceAvailabilityResponseItem,
  VirtualBookingDetails,
  VirtualBookingsDashboard,
  VirtualDashboardRequest,
  TeamRequestDashboardInput,
  TeamRequestDashboardResponse,
  VirtualRequestTaskRecords,
  CateringCount,
  Count,
  VirtualBookingModify,
  ConfirmMRModel,
  ConfirmMRResponse,
  MeetingWaitlistAuditItem,
  MeetingWaitListReleaseData,
  MeetingWaitListDetails,
  MeetingWaitlistStatus,
  VirtualDetails,
} from '../../../models/meetings.model';
import { DataContextService } from '../../datacontext.service';
import { Observable, throwError, ReplaySubject } from 'rxjs';
import { BookingsService } from '../Bookings/bookings.service';
import { FindASpaceService } from '../FindASpace/find-a-space.service';
import { DateHelper } from 'src/app/shared/Helper/dateHelper';
import * as moment from 'moment';
import { ReferenceType } from 'src/app/models/common.enums';
import { ReservationTasksBookingDetails } from 'src/app/models/tasks.model';
import { MeetingWaitlistInput, VirtualBookingInput } from 'src/app/models/find-a-space.model';
import { ToasterService, ToasterType } from 'src/app/common/toaster/toaster.service';

@Injectable({
  providedIn: 'root',
})
export class MeetingsService {
  info$ = new ReplaySubject<VirtualBookingDetails>(1);
  tasks$: ReplaySubject<ReservationTasksBookingDetails> = new ReplaySubject(1);
  reservationInfo$: ReplaySubject<ReservationDetails> = new ReplaySubject(1);
  constructor(
    private dataContextService: DataContextService,
    private findASpaceService: FindASpaceService,
    private bookingsService: BookingsService,
    private toasterService: ToasterService
  ) {}

  isContainerSelected: boolean;
  getMeetingDashboardData(input: MeetingsDashboardInput): Observable<MeetingDashboardResponse> {
    const url = `Reservations/MeetingDashboard`;
    return this.dataContextService.postData(url, input).pipe(
      map((res) => {
        if (res.status === 200) {
          const response = res.data as MeetingDashboardResponse;
          response.items.forEach((i) => {
            if (i.reservationSpecialist) {
              (i.reservationSpecialist.firstName = this.dataContextService.getUserFirstName(i.reservationSpecialist)),
                (i.reservationSpecialist.lastName = i.reservationSpecialist.lastName ? i.reservationSpecialist.lastName : '');
            }
            if (i.pointOfContact) {
              (i.pointOfContact.firstName = this.dataContextService.getUserFirstName(i.pointOfContact)),
                (i.pointOfContact.lastName = i.pointOfContact.lastName ? i.pointOfContact.lastName : '');
            }
          });
          return response;
        } else {
          return this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }
  getReservationItems(reservationId: number, input?: ReservationItemsInput): Observable<ReservationItemsResponse> {
    const url = `Reservation/${reservationId}/ReservationItems`;
    return this.dataContextService.postData(url, input).pipe(
      map((res) => {
        if (res.status === 200) {
          const response = res.data as ReservationItemsResponse;
          response.items.forEach((i) => {
            if (i.virtualBooking) {
              if (i.virtualBooking.producer) {
                (i.virtualBooking.producer.firstName = this.dataContextService.getUserFirstName(i.virtualBooking.producer)),
                  (i.virtualBooking.producer.lastName = i.virtualBooking.producer.lastName ? i.virtualBooking.producer.lastName : '');
              }
              if (i.virtualBooking.facilitator) {
                (i.virtualBooking.facilitator.firstName = this.dataContextService.getUserFirstName(i.virtualBooking.facilitator)),
                  (i.virtualBooking.facilitator.lastName = i.virtualBooking.facilitator.lastName
                    ? i.virtualBooking.facilitator.lastName
                    : '');
              }
            }
            if (i.spaceBooking) {
              if (i.spaceBooking.specialist) {
                (i.spaceBooking.specialist.firstName = this.dataContextService.getUserFirstName(i.spaceBooking.specialist)),
                  (i.spaceBooking.specialist.lastName = i.spaceBooking.specialist.lastName ? i.spaceBooking.specialist.lastName : '');
              }
            }
          });
          if (response.reservationItemFacets && response.reservationItemFacets.spaceBookingSpecialists) {
            response.reservationItemFacets.spaceBookingSpecialists.forEach((i) => {
              (i.firstName = this.dataContextService.getUserFirstName(i)), (i.lastName = i.lastName ? i.lastName : '');
            });
          }
          return response;
        } else {
          return this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }
  getReservationDetails(reservationId: number, features?: string): Observable<ReservationDetails> {
    const url = `Reservations/${reservationId}${features ? `?reservationFeatureFlags=${features}` : ''}`;
    return this.dataContextService.getData(url).pipe(
      map((res) => {
        if (res.status == 200) {
          const response = res.data as ReservationDetails;
          if (response.owner) {
            response.owner.firstName = this.dataContextService.getUserFirstName(response.owner);
            response.owner.lastName = response.owner.lastName ? response.owner.lastName : '';
          }
          if (response.pointOfContact) {
            response.pointOfContact.firstName = this.dataContextService.getUserFirstName(response.pointOfContact);
            response.pointOfContact.lastName = response.pointOfContact.lastName ? response.pointOfContact.lastName : '';
          }
          if (response.specialist) {
            response.specialist.firstName = this.dataContextService.getUserFirstName(response.specialist);
            response.specialist.lastName = response.specialist.lastName ? response.specialist.lastName : '';
          }
          return response;
        } else {
          this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }

  editReservationDetails(reservationId: number, input: EditReservationDetails): Observable<ReservationDetails> {
    const url = `Reservations/${reservationId}`;
    return this.dataContextService.putData(url, input).pipe(
      map((res) => {
        if (res.status == 200) {
          return res.data as ReservationDetails;
        } else {
          this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }
  bulkEdit(reservationId: number, input: BulkEditInput): Observable<IdWithRevision> {
    const url = `Reservations/${reservationId}/BookingModify`;
    return this.dataContextService.patchData(url, input).pipe(
      map((res) => {
        if (res.status == 200) {
          return res.data as IdWithRevision;
        } else {
          this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }
  bulkChangeSpace(reservationId: number, input: BulkChangeSpaceInput): Observable<IdWithRevision> {
    const url = `Reservations/${reservationId}/SpaceChange`;
    return this.dataContextService.patchData(url, input).pipe(
      map((res) => {
        if (res.status == 200) {
          return res.data as IdWithRevision;
        } else {
          this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }
  bulkCopy(userId: number, reservationId: number, input: BulkCopyInput): Observable<IdWithRevision> {
    const url = `Users/${userId}/Reservations/${reservationId}/Copy`;
    return this.dataContextService.patchData(url, input).pipe(
      map((res) => {
        if (res.status == 200) {
          return res.data as IdWithRevision;
        } else {
          this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }
  bulkMove(userId: number, reservationId: number, input: BulkInput): Observable<IdWithRevision> {
    const url = `Users/${userId}/Reservations/${reservationId}/Move`;
    return this.dataContextService.patchData(url, input).pipe(
      map((res) => {
        if (res.status == 200) {
          return res.data as IdWithRevision;
        } else {
          this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }
  bulkRelease(input: ReleaseSpaceBookingInput[]) {
    return this.bookingsService.releaseBooking(input);
  }
  checkSpaceAvailability(userId: number, input: SpaceAvailabilityInput) {
    const url = `Users/${userId}/Spaces/Availability`;
    return this.dataContextService.postData(url, input).pipe(
      map((res) => {
        if (res.status == 200) {
          return res.data as SpaceAvailabilityResponseItem[];
        } else {
          this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }
  getDTeamRequestDashboardData(input: TeamRequestDashboardInput): Observable<TeamRequestDashboardResponse> {
    let url = `TeamRequestItems/Dashboard?Filter.StartDate=${input.startDate}&Filter.EndDate=${input.endDate}&`;
    if (input.term) url += `Term=${input.term}&`;
    if (input.features) url += `Featuers=${input.features}&`;
    if (input.teamRequestId) url += `TeamRequestId=${input.teamRequestId}&`;
    if (input.orderType) url += `Sorting.OrderType=${input.orderType}&`;
    if (input.teamRequestItemDashboardSortingType)
      url += `Sorting.TeamRequestItemDashboardSortingType=${input.teamRequestItemDashboardSortingType}&`;
    if (input.spaceTypes && input.spaceTypes.length) {
      input.spaceTypes.forEach((type) => {
        url += `SpaceTypes=${type}&`;
      });
    }
    if (input.userIds && input.userIds.length) {
      input.userIds.forEach((id) => {
        url += `UserIds=${id}&`;
      });
    }
    if (input.requestedByIds && input.requestedByIds.length) {
      input.requestedByIds.forEach((id) => {
        url += `RequestedByIds=${id}&`;
      });
    }
    if (input.buildingIds && input.buildingIds.length) {
      input.buildingIds.forEach((id) => {
        url += `BuildingIds=${id}&`;
      });
    }
    if (input.limit) url += `Limit=${input.limit}&`;
    if (input.page >= 0) url += `Page=${input.page}`;
    return this.dataContextService.getData(url).pipe(
      map((res) => {
        if (res.status === 200) {
          const data = res.data as TeamRequestDashboardResponse;
          data.items.forEach((i) => {
            if (i.user) {
              i.user.firstName = this.dataContextService.getUserFirstName(i.user);
              i.user.lastName = i.user.lastName ? i.user.lastName : '';
            }
            if (i.requestedBy) {
              i.requestedBy.firstName = this.dataContextService.getUserFirstName(i.requestedBy);
              i.requestedBy.lastName = i.requestedBy.lastName ? i.requestedBy.lastName : '';
            }
          });
          return data;
        } else {
          return this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }
  deleteTeamRequest(temRequestId: string) {
    return this.findASpaceService.confirmTeamRequest(temRequestId);
  }

  //meeting request dashboard api calls

  //in-office dashboard call
  getInOfficeDashboardData(obj: InOfficeDashboardRequest, showSpinner: boolean = true): Observable<MeetingWaitlistDashboard> {
    const url = `MeetingWaitLists/Dashboard`;
    return this.dataContextService.postData(url, obj, showSpinner).pipe(
      map((res) => {
        if (res.status === 200) {
          const data = res.data as MeetingWaitlistDashboard;
          data.items.forEach((i) => {
            if (i.owner) {
              (i.owner.firstName = this.dataContextService.getUserFirstName(i.owner)),
                (i.owner.lastName = i.owner.lastName ? i.owner.lastName : '');
            }
            if (i.reservationSpecialist) {
              (i.reservationSpecialist.firstName = this.dataContextService.getUserFirstName(i.reservationSpecialist)),
                (i.reservationSpecialist.lastName = i.reservationSpecialist.lastName ? i.reservationSpecialist.lastName : '');
            }
            if (i.pointOfContact) {
              (i.pointOfContact.firstName = this.dataContextService.getUserFirstName(i.pointOfContact)),
                (i.pointOfContact.lastName = i.pointOfContact.lastName ? i.pointOfContact.lastName : '');
            }
          });
          return data;
        } else {
          return this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }

  //change request type of in-office
  changeReqType(meetingRequestId, data: { meetingWaitListRequestType: string }) {
    const url = 'MeetingWaitLists/' + meetingRequestId + '/RequestType';
    return this.dataContextService.patchData(url, data, false).pipe(
      map((res) => {
        if (res.status == 200) {
          return res.data;
        } else {
          this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }

  //virtual booking dashboard api call
  getVirtualDashboardData(data: VirtualDashboardRequest, showSpinner: boolean = true): Observable<VirtualBookingsDashboard> {
    const url = `VirtualBookings/Dashboard`;
    return this.dataContextService.postData(url, data, showSpinner).pipe(
      map((res) => {
        if (res.status === 200) {
          const data = res.data as VirtualBookingsDashboard;
          data.items.forEach((i) => {
            if (i.reservationSpecialist) {
              (i.reservationSpecialist.firstName = this.dataContextService.getUserFirstName(i.reservationSpecialist)),
                (i.reservationSpecialist.lastName = i.reservationSpecialist.lastName ? i.reservationSpecialist.lastName : '');
            }
            if (i.owner) {
              (i.owner.firstName = this.dataContextService.getUserFirstName(i.owner)),
                (i.owner.lastName = i.owner.lastName ? i.owner.lastName : '');
            }
            if (i.pointOfContact) {
              (i.pointOfContact.firstName = this.dataContextService.getUserFirstName(i.pointOfContact)),
                (i.pointOfContact.lastName = i.pointOfContact.lastName ? i.pointOfContact.lastName : '');
            }
            if (i.producer) {
              (i.producer.firstName = this.dataContextService.getUserFirstName(i.producer)),
                (i.producer.lastName = i.producer.lastName ? i.producer.lastName : '');
            }
            if (i.facilitator) {
              (i.facilitator.firstName = this.dataContextService.getUserFirstName(i.facilitator)),
                (i.facilitator.lastName = i.facilitator.lastName ? i.facilitator.lastName : '');
            }
          });
          return data;
        } else {
          return this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }

  //update virtual producer
  updateProducer(virtualBookingId, eventOwnerId, data: { producerId: number; revision: number }) {
    const url = 'VirtualBookings/' + virtualBookingId + '/Producer';
    return this.dataContextService.patchData(url, data, false).pipe(
      map((res) => {
        if (res.status == 200) {
          return res;
        } else {
          this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }

  //update virtual facilitator
  updateFacilitator(virtualBookingId, eventOwnerId, data: { facilitatorId: number; revision: number }) {
    const url = 'VirtualBookings/' + virtualBookingId + '/Facilitator';
    return this.dataContextService.patchData(url, data, false).pipe(
      map((res) => {
        if (res.status == 200) {
          return res;
        } else {
          this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }

  //in-office details call
  getInOfficeDetails(id: number): Observable<MeetingWaitListDetails> {
    const url = `MeetingWaitLists/${id}`;
    return this.dataContextService.getData(url).pipe(
      map((res) => {
        if (res.status === 200) {
          const response = res.data as MeetingWaitListDetails;
          if (response.owner) {
            response.owner.firstName = this.dataContextService.getUserFirstName(response.owner);
            response.owner.lastName = response.owner.lastName ? response.owner.lastName : '';
          }
          return response;
        } else {
          return this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }

  serviceOrderCount(bookingId: number, referenceType: string): Observable<CateringCount> {
    const url = `ServiceOrders/Count/Booking/${referenceType}/${bookingId}`;
    return this.dataContextService.getData(url).pipe(
      map((res) => {
        if (res.status == 200) {
          return res.data as CateringCount;
        } else {
          this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }

  confirmMeetingRequest(id: number, input: ConfirmMRModel) {
    const url = `MeetingWaitLists/${id}/Confirm`;
    return this.dataContextService.patchData(url, input, true).pipe(
      map((res) => {
        if (res.status == 200) {
          return res.data as ConfirmMRResponse;
        } else {
          return this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }

  getMeetingWaitlistAuditTrail(id: number): Observable<MeetingWaitlistAuditItem[]> {
    const url = `MeetingWaitListAuditTrailItems/${id}`;
    const dateProperty = {
      Startdate: 'Start time',
      Enddate: 'End time',
    };
    const floor = 'Floor';
    const booleanField = ['Flexibledateandtime', 'Isprivate'];
    const notRequired = ['Grantedreservation', 'Addtocalendar', 'Createdate', 'Space', 'Grantedbooking'];
    const statusType = 'Statustype';
    const requestType = 'Requesttype';
    const setupType = 'Setuptype';
    let floorSelectedOnCreation = false;

    return this.dataContextService.getData(url).pipe(
      map((res) => {
        let meetingWaitlistAuditItems: MeetingWaitlistAuditItem[] = [];
        if (res.status == 200) {
          const auditItems = res.data;
          auditItems.forEach((item) => {
            const changeBy = `${item.changeBy.firstName} ${item.changeBy.lastName}`;
            const changeDate = item.changeDate;
            item.fieldChangeAuditTrailItems.forEach((fieldItem) => {
              const key = fieldItem.name.replace(/\s/g, '');
              const timeProperty = dateProperty[key];
              if (!notRequired.some((n) => n == key)) {
                if (timeProperty) {
                  const newtime = fieldItem.newValue ? moment(DateHelper.RemoveOffsetFromDate(fieldItem.newValue)).format('h:mm A') : '-';
                  const oldTime = fieldItem.oldValue ? moment(DateHelper.RemoveOffsetFromDate(fieldItem.oldValue)).format('h:mm A') : '-';
                  const newDate = fieldItem.newValue
                    ? moment(DateHelper.RemoveOffsetFromDate(fieldItem.newValue)).format('MM/DD/YYYY')
                    : '-';
                  const oldDate = fieldItem.oldValue
                    ? moment(DateHelper.RemoveOffsetFromDate(fieldItem.oldValue)).format('MM/DD/YYYY')
                    : '-';
                  meetingWaitlistAuditItems.push({
                    valueChange: this.removeSpace(timeProperty),
                    oldValue: oldTime,
                    newValue: newtime,
                    changedBy: changeBy,
                    changedDate: changeDate,
                  });
                  meetingWaitlistAuditItems.push({
                    valueChange: this.removeSpace(fieldItem.name),
                    oldValue: oldDate,
                    newValue: newDate,
                    changedBy: changeBy,
                    changedDate: changeDate,
                  });
                } else if (key == floor) {
                  floorSelectedOnCreation = true;
                  if (item.auditTrailItemEventType == 'Added') {
                    meetingWaitlistAuditItems.push({
                      valueChange: this.removeSpace(fieldItem.name),
                      oldValue: '-',
                      newValue: fieldItem.newValue,
                      changedBy: changeBy,
                      changedDate: changeDate,
                    });
                  } else if (item.auditTrailItemEventType == 'Changed') {
                    meetingWaitlistAuditItems.push({
                      valueChange: this.removeSpace(fieldItem.name),
                      oldValue: fieldItem.oldValue ? fieldItem.oldValue.replace(/\bFloor\b/, this.dataContextService.translateText('Translation.Floor')) : this.dataContextService.translateText('Translation.Any'),
                      newValue: fieldItem.newValue ? fieldItem.newValue.replace(/\bFloor\b/, this.dataContextService.translateText('Translation.Floor')) : this.dataContextService.translateText('Translation.Any'),
                      changedBy: changeBy,
                      changedDate: changeDate,
                    });
                  }
                } else if (booleanField.some((b) => b == key)) {
                  meetingWaitlistAuditItems.push({
                    valueChange: this.removeSpace(fieldItem.name),
                    oldValue: fieldItem.oldValue == null ? '-' : fieldItem.oldValue === 'True' ? this.dataContextService.translateText('Translation.Yes') : this.dataContextService.translateText('Translation.No'),
                    newValue: fieldItem.newValue == null ? '-' : fieldItem.newValue === 'True' ? this.dataContextService.translateText('Translation.Yes') : this.dataContextService.translateText('Translation.No'),
                    changedBy: changeBy,
                    changedDate: changeDate,
                  });
                } else if (statusType == key) {
                  meetingWaitlistAuditItems.push({
                    valueChange: this.removeSpace(fieldItem.name),
                    oldValue: fieldItem.oldValue
                      ? DataContextService.MeetingWaitlistStatus.find((status) => status.name == fieldItem.oldValue).displayName
                      : '-',
                    newValue: fieldItem.newValue
                      ? DataContextService.MeetingWaitlistStatus.find((status) => status.name == fieldItem.newValue).displayName
                      : '-',
                    changedBy: changeBy,
                    changedDate: changeDate,
                  });
                } else if (setupType == key) {
                  meetingWaitlistAuditItems.push({
                    valueChange: this.removeSpace(fieldItem.name),
                    oldValue: fieldItem.oldValue
                      ? DataContextService.SpaceSetupTypes.find((type) => type.id == fieldItem.oldValue).description
                      : '-',
                    newValue: fieldItem.newValue
                      ? DataContextService.SpaceSetupTypes.find((type) => type.id == fieldItem.newValue).description
                      : '-',
                    changedBy: changeBy,
                    changedDate: changeDate,
                  });
                } else if (requestType == key) {
                  meetingWaitlistAuditItems.push({
                    valueChange: this.removeSpace(fieldItem.name),
                    oldValue: fieldItem.oldValue
                      ? DataContextService.MeetingWaitlistRequestTypes.find((type) => type.name == fieldItem.oldValue).displayName
                      : '-',
                    newValue: fieldItem.newValue
                      ? DataContextService.MeetingWaitlistRequestTypes.find((type) => type.name == fieldItem.newValue).displayName
                      : '-',
                    changedBy: changeBy,
                    changedDate: changeDate,
                  });
                } else {
                  meetingWaitlistAuditItems.push({
                    valueChange: this.removeSpace(fieldItem.name),
                    oldValue: fieldItem.oldValue ? fieldItem.oldValue : '-',
                    newValue: fieldItem.newValue ? fieldItem.newValue : '-',
                    changedBy: changeBy,
                    changedDate: changeDate,
                  });
                }
              }
            });
            if (item.auditTrailItemEventType == 'Added' && !floorSelectedOnCreation) {
              meetingWaitlistAuditItems.push({
                valueChange:'Floor',
                oldValue: '-',
                newValue: this.dataContextService.translateText('Translation.Any'),
                changedBy: changeBy,
                changedDate: changeDate,
              });
            }
          });
        }

        return meetingWaitlistAuditItems.filter((item) => item.oldValue != item.newValue);
      })
    );
  }

  cancelMeetingRequest(data: MeetingWaitListReleaseData) {
    const url = `MeetingWaitLists`;
    return this.dataContextService.deleteData(url, data);
  }
  editEventOwner(reservationId: number, eventOwnerId: number): Observable<boolean> {
    const url = `Reservations/${reservationId}/Owner`;
    return this.dataContextService.patchData(url, { ownerId: eventOwnerId }).pipe(
      map((res) => {
        if (res.status === 200) return true;
        return false;
      })
    );
  }

  getVirtualBookingDetails(meetingId) {
    const url = `VirtualBookings/${meetingId}`;
    return this.dataContextService.getData(url).pipe(
      map((res) => {
        if (res.status === 200) {
          const response = res.data as VirtualBookingDetails;
          if (response.producer) {
            response.producer.firstName = this.dataContextService.getUserFirstName(response.producer);
            response.producer.lastName = response.producer.lastName ? response.producer.lastName : '';
          }
          if (response.facilitator) {
            response.facilitator.firstName = this.dataContextService.getUserFirstName(response.facilitator);
            response.facilitator.lastName = response.facilitator.lastName ? response.facilitator.lastName : '';
          }
          if (response.createBy) {
            response.createBy.firstName = this.dataContextService.getUserFirstName(response.createBy);
            response.createBy.lastName = response.createBy.lastName ? response.createBy.lastName : '';
          }
          return response;
        } else {
          return this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }

  getTaskAuditTrail(id: number, type: ReferenceType, page = 1, limit = 50): Observable<VirtualRequestTaskRecords> {
    const url = `TaskAuditTrail?ReferenceType=${ReferenceType[type]}&Id=${id}&Limit=${limit}&Page=${page}`;
    return this.dataContextService.getData(url).pipe(
      map((res) => {
        if (res.status === 200) {
          return { items: res.data.items, totalCount: res.data.totalCount } as VirtualRequestTaskRecords;
        } else {
          this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }

  addVirtualBooking(reservationId: number, input: VirtualBookingInput) {
    const url = `Reservations/${reservationId}/VirtualBookings`;
    return this.dataContextService.postData(url, input, true).pipe(
      map((res) => {
        if (res.status === 200) {
          this.toasterService.show({
            message: this.dataContextService.translateText('Translation.Component_added_successfully'),
            type: ToasterType.success,
          });
          return res.data as VirtualBookingDetails;
        } else {
          return this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }

  addMeetingWaitlistBooking(reservationId: number, input: MeetingWaitlistInput) {
    const url = `Reservations/${reservationId}/MeetingWaitlists`;
    return this.dataContextService.postData(url, input, true).pipe(
      map((res) => {
        if (res.status === 200) {
          this.toasterService.show({
            message: this.dataContextService.translateText('Translation.Component_added_successfully'),
            type: ToasterType.success,
          });
          return res.data as MeetingWaitListDetails;
        } else {
          return this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }
  private removeSpace(value: string): string {
    return value.replace(/\s/g, '');
  }
}
